import { render } from "./BackgroundForModals.vue?vue&type=template&id=b9c808c8&scoped=true"
import script from "./BackgroundForModals.vue?vue&type=script&lang=js"
export * from "./BackgroundForModals.vue?vue&type=script&lang=js"

import "./BackgroundForModals.vue?vue&type=style&index=0&id=b9c808c8&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9c808c8"]])

export default __exports__